var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 1.161a.249.249 0 00-.466 0l-.53 1.433a.237.237 0 01-.143.143l-1.433.53a.249.249 0 000 .466l1.433.53a.237.237 0 01.143.143l.53 1.433a.249.249 0 00.466 0l.53-1.433a.237.237 0 01.143-.143l1.433-.53a.249.249 0 000-.466l-1.432-.53a.237.237 0 01-.144-.143l-.53-1.433z",
    fill: "url(#magnifying_glass_svg__paint0_linear_329_1396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.584 2.318a1.762 1.762 0 00-.437 1.405 4.033 4.033 0 103.17 3.582 1.802 1.802 0 001.476.07 5.476 5.476 0 01-1.12 3.628L14.3 13.63a.733.733 0 11-1.037 1.037l-2.627-2.627a5.5 5.5 0 11-2.052-9.722z",
    fill: "url(#magnifying_glass_svg__paint1_linear_329_1396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magnifying_glass_svg__paint0_linear_329_1396",
    x1: 14.299,
    y1: 0.654,
    x2: 0.235,
    y2: 14.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3454FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C941FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "magnifying_glass_svg__paint1_linear_329_1396",
    x1: 14.299,
    y1: 0.654,
    x2: 0.235,
    y2: 14.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3454FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C941FF"
  })))));
}
export default SvgMagnifyingGlass;